// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"314":"af32f140","636":"febad96a","675":"a3223697","785":"4c7c742a","806":"649b32df"}[chunkId] + ".chunk.js";
};